var _rect, _line, _path, _path2, _path3, _path4, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _path5, _path6, _line11, _line12, _line13, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAtiniLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 241,
    height: 277,
    viewBox: "0 0 241 277",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 233,
    height: 269,
    stroke: "#728F8B",
    strokeWidth: 8
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 196,
    y1: 148,
    x2: 196,
    y2: 244,
    stroke: "#FCAE4C",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.55 154.75L87.8694 148H95.2306L91.55 154.75Z",
    fill: "#5A9E95"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M104.6 156.5L100.183 148.025H109.017L104.6 156.5Z",
    fill: "#5A9E95"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M137.4 235.2L141.817 244.2H132.983L137.4 235.2Z",
    fill: "#5A9E95"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M151.7 235L156.117 244H147.283L151.7 235Z",
    fill: "#5A9E95"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 154,
    y1: 148,
    x2: 154,
    y2: 244.005,
    stroke: "#5A9E95",
    strokeWidth: 8
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 91.5485,
    y1: 149.753,
    x2: 136.526,
    y2: 242.414,
    stroke: "#5A9E95",
    strokeWidth: 8
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 105.593,
    y1: 149.742,
    x2: 150.85,
    y2: 242.267,
    stroke: "#5A9E95",
    strokeWidth: 8
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 87,
    y1: 148,
    x2: 87,
    y2: 244,
    stroke: "#5A9E95",
    strokeWidth: 8
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 44,
    y1: 148,
    x2: 44,
    y2: 244,
    stroke: "#C9C0C5",
    strokeWidth: 8
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 162,
    y1: 37,
    x2: 162,
    y2: 125,
    stroke: "#AEAB00",
    strokeWidth: 8
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 170,
    y1: 33,
    x2: 205,
    y2: 33,
    stroke: "#AEAB00",
    strokeWidth: 8
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 131,
    y1: 33,
    x2: 166,
    y2: 33,
    stroke: "#AEAB00",
    strokeWidth: 8
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 174,
    y1: 37,
    x2: 174,
    y2: 125,
    stroke: "#AEAB00",
    strokeWidth: 8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32 115.5L36.3301 125.25H27.6699L32 115.5Z",
    fill: "#FCAE4C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M115.525 115.95L120.093 124.2H110.957L115.525 115.95Z",
    fill: "#FCAE4C"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 52.8053,
    y1: 78.6246,
    x2: 32.8053,
    y2: 123.625,
    stroke: "#FCAE4C",
    strokeWidth: 8
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    y1: -4,
    x2: 47.735,
    y2: -4,
    transform: "matrix(-0.448852 -0.893606 0.832841 -0.553512 117.576 119.656)",
    stroke: "#FCAE4C",
    strokeWidth: 8
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 49.15,
    y1: 81,
    x2: 96.15,
    y2: 81,
    stroke: "#FCAE4C",
    strokeWidth: 8
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2305 70L72.65 37.8043L89.0696 70H56.2305Z",
    stroke: "#FCAE4C",
    strokeWidth: 8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtiniLogo);
export default __webpack_public_path__ + "static/media/atini-logo.777115fe51e703f5440be70c94d62bb2.svg";
export { ForwardRef as ReactComponent };